var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-cropper-control"
  }, [_c('ugc-crop-box', {
    ref: "cropbox",
    attrs: {
      "fabric-canvas": this.fabricCanvas,
      "temp-crop-data": this.tempCropData,
      "image-format": this.imageFormat
    }
  }), _c('p', {
    staticClass: "ugc-cropper-control-text"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.ugcCropperControlDesc) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }